import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import { toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import ViewUser from "./ViewUser";



const PassiveUser = () => {
  const [userList, setUserList] = useState([]);
  const [change, setChange ] = useState(false)
  const [user, setUser] = useState(0)

  useEffect(() => {
    api
      .get("users/?is_active=false")
      .then((response) => {
        // console.log(response.data);
        setUserList(response.data)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [change]);

  
  const handleActive = (id) => {
    api.patch(`/users/${id}/activate/`)
    .then(response=> {
      setChange(!change)
    }).catch(error=> {
      toast.error("something went wrong")
    })
  }

  const handleSearch = (e) => {

    api.get(`users/?is_active=false&search${e.target.value}`)
    .then(response=> {
      setUserList(response.data)
    }).catch(error=> {
      console.log(error)
    })
  
  }

  const printRef=useRef(null)

  const print=useReactToPrint({
    content:() =>printRef.current
  })

  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Passive User Create List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                {/* search */}
                <div className="flex justify-between">
                 
                  <input
                    placeholder="Search by Staff"
                    type="search"
                    onChange={(e)=> handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search by Date"
                    type="search"
                    onChange={(e)=> handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                </div>
                <table ref={printRef} className="border-primary-blue min-w-full border text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr className="">
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Create Date
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        User Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Address
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Contact No
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        User Id
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Password
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {
                    userList.length >= 1 ?
                    userList.map((item, i) => {
                      return (
                        <tr
                          className="border-primary-blue border-2 bg-white"
                          key={i}
                        >
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {i}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.created_at}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.user_name ? item.user_name : "Null"}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {/* Bharatpur-11 */}
                            {item.profile.address ? item.profile.address :"Null"}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {/* 99999999 */}
                            {item.phone}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {/* 9999999 */}
                            {item.profile.user}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            111111
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            <button
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModalEdit"
                                onClick={()=>{setUser(item.profile.id)}}
                              className="bg-primary-green rounded-full p-1 px-2 text-white"
                            >
                              View
                            </button>
                            <ViewUser user={user}/>
                            <button
                              onClick={()=> handleActive(item.id)}
                              // href=""
                              className="bg-primary-red rounded-full p-1 px-2 text-white"
                            >
                              Active
                            </button>
                            {/* <a
                              href=""
                              className="bg-primary-blue rounded-full p-1 px-2 text-white"
                            >
                              Passive
                            </a> */}
                          </td>
                        </tr>
                      );

                    }) : "No data found"
                  
                  }
                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <button onClick={print}> Print List</button>
                  </div>
                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    <a href="">View More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default PassiveUser;
